module.exports = __webpack_public_path__ + "static/logo-25a773240777ce8c63d5d63b883120c1.png";